export default __webpack_public_path__ + "static/adana-demirspor-logo-b766a29edebbef35e6ebb5d19beff7c4.png";